import { useTranslation } from "react-i18next";
import { TextAndCallIcon } from "../TextAndCallIcon";

export const AwaitingConfirmation = () => {
  const { t } = useTranslation("onboarding");

  return (
    <div className="flex flex-col gap-6 justify-center items-center">
      <div className="relative">
        <TextAndCallIcon className="w-[96px] h-[96px] text-gray-400" />
        <div className="w-6 h-6 rounded-full bg-orange-500 absolute -right-1 -top-1 aspect-square text-white flex items-center justify-center">
          <span className="text-white text-sm font-bold leading-none">!</span>
        </div>
      </div>
      <div className="flex flex-col items-center gap-1">
        <p className="text-muted-foreground">
          {t("Your texting and calling account is currently awaiting confirmation.")}
        </p>
        <p className="text-xs text-muted-foreground">{t("Powered by Twilio")}</p>
      </div>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 max-w-[520px]">
        <div className="flex items-start space-x-3">
          <svg
            className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <div className="text-left">
            <h5 className="font-medium text-blue-900 mb-1">{t("What happens next?")}</h5>
            <p className="text-sm text-blue-700">
              {t(
                "You'll receive an email confirmation once your account is verified. After that, return to Settings to configure your phone numbers and messaging preferences."
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
